const getAuthStorage = () => (
  !localStorage.getItem("token") && sessionStorage.getItem("token")
    ? sessionStorage
    : localStorage
);

// Save authentication data in persistent or tab-session storage.
export const setAuthData = (token, user, rememberMe) => {
  const storage = typeof rememberMe === "boolean"
    ? rememberMe ? localStorage : sessionStorage
    : getAuthStorage();
  const otherStorage = storage === localStorage ? sessionStorage : localStorage;
  if (token) {
    storage.setItem("token", token);
    otherStorage.removeItem("token");
  }
  if (user) {
    storage.setItem("user", JSON.stringify(user));
    otherStorage.removeItem("user");
  }
  if (typeof window !== "undefined" && user) {
    window.dispatchEvent(new Event("auth:user-updated"));
  }
};

// Get logged-in user
export const getLoggedInUser = () => {
  const storage = getAuthStorage();
  const user = storage.getItem("user");
  if (!user) return null;
  try {
    return JSON.parse(user);
  } catch {
    storage.removeItem("user");
    return null;
  }
};

// Get token
export const getToken = () => {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
};

// Check login
export const isLoggedIn = () => {
  return !!getToken();
};

// Logout
export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  // Signing out of a customer session started by an admin also discards the admin session set aside for it.
  localStorage.removeItem("impersonation.adminSession");
  sessionStorage.removeItem("impersonation.adminSession");
};
